import Settings from "./Settings";
import { AuthToken } from "./AuthToken";

import ProcessingResult from "../framework/ProcessingResult";

import GetDataSourceTypesLabelsResult from "../classes/api/result/localizationmodule/GetDataSourceTypesLabelsResult";
import DataSourceTypeLabelDto from "../classes/dtos/localizationmodule/DataSourceTypeLabelDto";

const LocalizationApi = {

    GetDataSourceTypesLabelsAsync: async function (): Promise<ProcessingResult<GetDataSourceTypesLabelsResult>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/Localization/GetDataSourceTypesLabels?cultureInfo=en-GB", {
            method: "Get",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            }
        });

        if (response.status === 200) {
            let data = await response.json();
            return ProcessingResult.Ok(new GetDataSourceTypesLabelsResult(data.labels.map((e: any) => new DataSourceTypeLabelDto(e.dataSourceType, e.reference, e.label))));
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    }
};

export default LocalizationApi;